import { Component } from '@angular/core';

@Component({
  selector: 'swb-user-detail',
  templateUrl: './user.component.html'
})
export class UserComponent {

}
